import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Alert } from '../ui/primitives'
import { INTEGRATION_LIMIT_EVENT } from '../services/integrationLimitEvent'

/**
 * Shown when the console refuses to connect an integration because the
 * license's integration limit is reached. Whatever page made the request, the
 * customer gets one clear next step: buy more on the License page.
 */
export default function IntegrationLimitNotice() {
  const [limit, setLimit] = useState(null)

  useEffect(() => {
    const onLimit = (event) => setLimit(event.detail ?? {})
    window.addEventListener(INTEGRATION_LIMIT_EVENT, onLimit)
    return () => window.removeEventListener(INTEGRATION_LIMIT_EVENT, onLimit)
  }, [])

  if (!limit) return null
  const counted = Number.isInteger(limit.used) && Number.isInteger(limit.allowed)
  return (
    <div className="px-4 pt-3" data-testid="integration-limit-notice">
      <Alert color="warning" className="flex flex-wrap items-center gap-3">
        <span>
          {counted
            ? `Your license allows ${limit.allowed} integrations and ${limit.used} are connected.`
            : 'Your license does not allow another integration.'}
        </span>
        <Link to="/license" onClick={() => setLimit(null)} className="font-semibold underline">
          Buy more integrations
        </Link>
        <button type="button" className="ml-auto text-xs underline" onClick={() => setLimit(null)}>
          Dismiss
        </button>
      </Alert>
    </div>
  )
}
